import BaseService from "@/services/BaseService";
export default class CityService extends BaseService{
  constructor() {
    super('odoo/city');
  }

  async FindAll(name) {
    return await this.http.get(this._serviceName+'/filter', { params: {'name':name} });
  }
  async FindById(id) {
    return await this.http.get(this._serviceName+`/${id}`);
  }
}
